let config = {       
    groupings: ['Product Type','Dimensions','Fabric','Attributes','Ratio'],
    filters:[
        {text:'Search',operation:''},
        {tag:'Product Type'},
        {tag:'Dimensions'},
        {tag:'Fabric'},
        {tag:'Attributes'},
        {tag:'Ratio'},
    ],
    pageSize: 24,
    orderBy: '-CreatedOn,Id',
    sortOptions: {
        'Sku': 'Item Number: Low to High',
        '-Sku': 'Item Number: High to Low',
        'Description,Id': 'Description: A to Z',
        '-Description,Id': 'Description: Z to A',
        'Cost,Id': 'Cost: Low to High',
        '-Cost,Id': 'Cost: High to Low',
        'CreatedOn,Id': 'Created: Newest',
        '-CreatedOn,Id': 'Created: Oldest',
        'Active,Id': 'Active: A to Z',
        '-Active,Id': 'Active: Z to A',
    }
};

export default config;